/*
 * Honest rendering of possibly-absent evidence.
 *
 * The single rule: null means the server could not substantiate the metric and renders
 * "Unknown"; a backend-PROVEN zero renders "0". Collapsing the two — with `?? 0` or `|| 0` —
 * turns "we don't know" into "we measured none", which is the difference between an honest
 * console and a misleading one.
 */

export const UNKNOWN_LABEL = 'Unknown';

export const renderMetric = (value: number | null): string =>
  value === null ? UNKNOWN_LABEL : String(value);

export const renderText = (value: string | null): string =>
  value === null || value === '' ? UNKNOWN_LABEL : value;

/** Highlighting requires a real number above zero. null must never light an alert. */
export const isPositive = (value: number | null): boolean =>
  typeof value === 'number' && value > 0;

/**
 * A worker can be selected into the wave before any action evidence exists. That is a real,
 * honest state — not an error and not an offer. It renders with plain tone so it cannot be
 * mistaken for a decision that was actually taken.
 */
export const NO_ACTION_RECORDED_LABEL = 'No action recorded';

export const hasActionEvidence = (decision: string | null): boolean =>
  decision !== null;
